


























































import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Player from '@/view-models/player';
import { io } from "socket.io-client";
@Component({
  components: {
    Modal
  },
})
export default class Game extends Vue {
  public isHovering = false;
  public modal = true;
  public showVotes = false;
  public showCopiedToClipboard = false;
  public countdown = 0;
  public interval: any = {};
  public name = "";
  public currentVote: any = null;

  public mounted() {
    if (this.joiningAGame()) {
      const socket = io(process.env.VUE_APP_SERVER, {
        query: {
          "roomId": this.$route.params.id
        }
      });
      store.commit('setSocket', socket);
    }

    const storedName = localStorage.getItem('name')
    if (storedName) {
      this.enteredName(storedName);
    }

    this.setupSocketHandlers();
  }

  public showVotesClicked() {
    store.state.socket.emit('show');
  }

  public getPlayers() {
    return store.state.players;
  }

  public performVote(vote: string) {
    store.state.socket.emit('vote', vote);
    this.currentVote = vote;
  }

  public startNewGame() {
    store.state.socket.emit('restart');
  }

  public enteredName(name: string) {
    this.name = name;
    this.emitName(name);
    localStorage.setItem('name', name);
    this.modal = false;
  }

  private emitName(name: string) {
    store.state.socket.emit('name', name);
  }

  public playerHasVoted() {
     const players = store.state.players;
     if (players.filter(p => p.vote !== null && p.vote !== undefined).length > 0) {
       return true;
     }
     return false;
  }

  public copyToClipboard() {
    const tempInput = document.createElement("input");
    tempInput.value = window.location.href;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    this.showCopiedToClipboard = true;
    setTimeout(() => this.showCopiedToClipboard = false, 3000);
  }

  public getAverage() {
    const players = store.state.players;
    let count = 0;
    let total = 0;
    for (const player of players) {
      if (player.vote && player.vote !== '?') {
        total += parseInt(player.vote);
        count++;
      }
    }


    return (total / count).toFixed(1).replace(/\.0+$/,'')
  }

  public getMode(): string {
    const players = store.state.players;
    const scores: Record<string, number> = {};
    for (const player of players) {
      if (player.vote) {

        if (scores[player.vote]) {
          scores[player.vote] = scores[player.vote] + 1;
        } else {
          scores[player.vote] = 1;
        }
      }
    }

    let mostSeen = 1;
    let mostSeenCard = '';
    for (const key in scores) {
      const value = scores[key];
      if (value > mostSeen) {
        mostSeen = value;
        mostSeenCard = key;
      }
    }

    if (mostSeen == 1) {
      return 'NA';
    } else {
      return mostSeenCard;
    }
  }


  public goToGithub() {
    open('https://github.com/LukeGarrigan/planfree.dev');
  }
  private joiningAGame() {
    const currentState = store.state.socket;
    return currentState && Object.keys(currentState).length === 0 && currentState.constructor === Object
  }

  private setupSocketHandlers() {
    store.state.socket.on('update', (players: Player[]) => {
      store.state.players = players;
    });

    store.state.socket.on('show', () => {
      this.showVotes = true;
      clearInterval(this.interval);
      this.countdown = 3;
      this.interval = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown == 0) {
          clearInterval(this.interval);
        }
      }, 1000)
    })

    store.state.socket.on('restart', () => {
      this.showVotes = false;
      this.currentVote = null;
    })

    store.state.socket.on('ping', () => {
      store.state.socket.emit('pong');
    })
  }
}

